import { useState } from "react";
import { NavProps } from "./data";
import { NavLink } from "react-router-dom";
import styles from "./subMenu.module.scss";

const activeStyle = {
  display: "flex",
  alignItems: "center",
  textDecoration: "none",
  fontWeight: 500,
  padding: "0.9rem",
  backgroundColor: "var(--color-navhovergreen-bg)",
  borderRadius: "16px",
  width: "100%",
};
const dropdownActiveStyle = {
  display: "flex",
  alignItems: "center",
  textDecoration: "none",
  fontWeight: 500,
  padding: "0.9rem",
  backgroundColor: "var(--color-navhovergreen-bg)",
  borderRadius: "16px",
  width: "100%",
};

const SubMenu: React.FC<NavProps> = ({ title, path, icon, subNav }) => {
  const [sub, setSub] = useState(false);
  const showSub = () => setSub((prev) => !prev);

  return (
    <>
      {path ? (
        <NavLink
          style={({ isActive }) => (isActive ? activeStyle : {})}
          className={styles.navLink}
          to={path}
        >
          {icon}
          <span>{title}</span>
        </NavLink>
      ) : (
        <div className={styles.navButton} onClick={subNav && showSub}>
          <div className={styles.wrapper}>
            {icon}
            <span>{title}</span>
          </div>
        </div>
      )}
      {sub && (
        <div className={styles.dropdownNavWrapper} style={{ width: "100%" }}>
          {subNav?.map((item, index) => (
            <NavLink
              key={index}
              style={({ isActive }) => (isActive ? dropdownActiveStyle : {})}
              className={styles.dropdownNavLink}
              to={item.path}
            >
              {item?.icon}
              <span>{item?.title}</span>
            </NavLink>
          ))}
        </div>
      )}
    </>
  );
};

export default SubMenu;
